import { render, staticRenderFns } from "./PendingApprovalAction.vue?vue&type=template&id=825e2fb8&scoped=true&"
import script from "./PendingApprovalAction.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalAction.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovalAction.vue?vue&type=style&index=0&id=825e2fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e2fb8",
  null
  
)

export default component.exports